// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"05f01041","453":"b6334f3d","796":"844eb455"}[chunkId] + ".chunk.js";
};